import script from "./LoginView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginView.vue?vue&type=script&lang=ts&setup=true"

import "./LoginView.vue?vue&type=style&index=0&id=37be690e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37be690e"]])

export default __exports__